import _findIndex from 'lodash/findIndex';

/**
 * @desc  ActivityService class.
 * @ngInject
 */
export default class ActivityService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $rootScope, $q, $log, $http
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;

    this.activities = [];

    // Change scr id, empty cache if school common room change
    this.$rootScope.$on('scr.select', () => {
      this.activities.splice(0, this.activities.length);
    });
  }

  add(activity, addToLocal = true) {
    const copyActivity = {};
    angular.copy(activity, copyActivity);
    return this.$http({
      method: 'POST',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/activity`,
      data: {activity}
    }).then(result => {
      copyActivity.id = result.data.id;
      if (addToLocal) {
        this.activities.unshift(copyActivity);
      }
    }, err => this.$q.reject(err));
  }

  get(monthId, fromServer = false) {
    if (this.activities.length > 0 && !fromServer) {
      return this.$q.resolve(this.activities);
    }

    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/activity`,
      params: {month: monthId}
    }).then(result => {
      angular.copy(result.data.activities, this.activities);
      return this.activities;
    }, err => this.$q.reject(err));
  }

  edit(activity) {
    return this.$http({
      method: 'PUT',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/activity/${activity.id}`,
      data: {activity}
    }).then(result => result, err => this.$q.reject(err));
  }

  delete(activityId) {
    return this.$http({
      method: 'DELETE',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/activity/${activityId}`
    }).then(() => {
      const idToRemove = _findIndex(this.activities, ['id', activityId]);
      this.activities.splice(idToRemove, 1);
      return activityId;
    }, err => this.$q.reject(err));
  }
}
